module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "background-color": "#EBECF1"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('h3', {
    staticClass: "fuente box-title p-t-10"
  }, [_vm._v(_vm._s(this.descripcionApp))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('vue-tabs', {
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "active-tab-color": "#C82626",
      "active-text-color": "white",
      "type": "pills",
      "text-position": "center",
      "centered": ""
    },
    on: {
      "tab-change": _vm.handleTabChange
    }
  }, [_c('v-tab', {
    attrs: {
      "title": " PERSONAL",
      "icon": "fa fa-users"
    }
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 border-table"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "tabla-1"
  }, [_c('div', {
    staticClass: "box-header",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modalNuevoPersonal"
    },
    on: {
      "click": function($event) {
        return _vm.getAllPersonal()
      }
    }
  }, [_vm._v("Nuevo Registro")])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "id": "tablaTrabajadores",
      "aria-describedby": "tablaTrabajadores_info",
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tablaTrabajadores",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  ITEM")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "DNI",
      "aria-controls": "tablaTrabajadores",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  DNI\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "NOMBRES",
      "aria-controls": "tablaTrabajadores",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  NOMBRES\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "CARGO",
      "aria-controls": "tablaTrabajadores",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  CARGO\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "CORREO",
      "aria-controls": "tablaTrabajadores",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  CORREO\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "SIGLA",
      "aria-controls": "tablaTrabajadores",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  SIGLA\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "FECHA NAC",
      "aria-controls": "tablaTrabajadores",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  FECHA\n                                  NACIMIENTO")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "USUARIO",
      "aria-controls": "tablaTrabajadores",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  USUARIO\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "DETALLE",
      "aria-controls": "tablaTrabajadores",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  DETALLE\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "ANULAR",
      "aria-controls": "tablaTrabajadores",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  ANULAR\n                                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.trabajadores), function(trabajador, indexTrab) {
    return _c('tr', {
      key: indexTrab.idTrabajador,
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(indexTrab + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trabajador.dni))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trabajador.nombres) + " " + _vm._s(trabajador.apePaterno) + " " + _vm._s(trabajador.apeMaterno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trabajador.cargo))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(trabajador.correo))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(trabajador.sigla))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.formatDate(trabajador.fecha_nac)))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(trabajador.nomUsuario))]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'usuarios',
          params: {
            idTrab: trabajador.idTrabajador
          }
        }
      }
    }, [_c('span', {
      staticClass: "badge bg-yellow",
      on: {
        "click": function($event) {
          return _vm.enviar(trabajador.correo, trabajador.idTrabajador)
        }
      }
    }, [_vm._v("V")])])], 1), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-red",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalAnularTrabxApp"
      },
      on: {
        "click": function($event) {
          return _vm.verAnularTrabxApp(trabajador)
        }
      }
    }, [_vm._v("X")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.error.desError) + "\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalNuevoPersonal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.texto)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body fs-12 input-personalizado"
  }, [_c('v-select', {
    staticClass: "fuente form-control m-t-10 m-b-10 combobox-personalizado",
    staticStyle: {
      "width": "100%",
      "max-width": "550px",
      "padding": "0px",
      "border-style": "hidden"
    },
    attrs: {
      "options": _vm.filteredUsuarios,
      "filterable": true,
      "label": "nombreCompleto",
      "placeholder": "Seleccionar Personal"
    },
    on: {
      "input": _vm.inputHandler
    },
    scopedSlots: _vm._u([{
      key: "no-options",
      fn: function(ref) {
        var search = ref.search;

        return [_vm._v("\n                                    Lo siento, no hay usuarios que coincidan con \"" + _vm._s(search) + "\".\n                                  ")]
      }
    }]),
    model: {
      value: (_vm.selectedIdPersonal),
      callback: function($$v) {
        _vm.selectedIdPersonal = $$v
      },
      expression: "selectedIdPersonal"
    }
  }), _vm._v(" "), (_vm.datosPer !== null) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                                      NOMBRES"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuarioSeleccionado.nombres),
      expression: "usuarioSeleccionado.nombres"
    }],
    staticClass: "form-control m-t-10 input-personalizado2",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.usuarioSeleccionado.nombres)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuarioSeleccionado, "nombres", $event.target.value)
      }
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                                      APELLIDOS"), _c('br'), _vm._v(" "), _c('input', {
    staticClass: "form-control m-t-10 input-personalizado2",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": ((_vm.usuarioSeleccionado.apePaterno || '') + " " + (_vm.usuarioSeleccionado.apeMaterno || ''))
    }
  }), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                                      DNI"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuarioSeleccionado.dni),
      expression: "usuarioSeleccionado.dni"
    }],
    staticClass: "form-control m-t-10 input-personalizado2",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.usuarioSeleccionado.dni)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuarioSeleccionado, "dni", $event.target.value)
      }
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                                      CARGO"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuarioSeleccionado.cargo),
      expression: "usuarioSeleccionado.cargo"
    }],
    staticClass: "form-control m-t-10 input-personalizado2",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.usuarioSeleccionado.cargo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuarioSeleccionado, "cargo", $event.target.value)
      }
    }
  }), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                                      CORREO"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuarioSeleccionado.correo),
      expression: "usuarioSeleccionado.correo"
    }],
    staticClass: "form-control m-t-10 input-personalizado2",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.usuarioSeleccionado.correo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuarioSeleccionado, "correo", $event.target.value)
      }
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                                      FECHA NACIMIENTO"), _c('br'), _vm._v(" "), _c('input', {
    staticClass: "form-control m-t-10 input-personalizado2",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.formatDate(_vm.usuarioSeleccionado.fecNacimiento)
    }
  }), _c('br')])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.datosPer !== null) ? _c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaUsers_info",
      "role": "grid",
      "id": "tablaUsers"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tablaUsers",
      "tabindex": "0"
    }
  }, [_vm._v("ITEM\n                                            ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "NOMBRE_USUARIO",
      "aria-controls": "tablaUsers",
      "tabindex": "0"
    }
  }, [_vm._v("NOMBRE USUARIO\n                                            ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "AGREGAR",
      "aria-controls": "tablaUsers",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                              AGREGAR\n                                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.datosPer), function(item, indexUsu) {
    return _c('tr', {
      key: indexUsu.idUsuario,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(indexUsu + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nomUsuario))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "fuente btn btn-primary fs-13 enabled-button2",
      attrs: {
        "type": "button",
        "data-dismiss": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.mergePersonal(item.idUsuario)
        }
      }
    }, [_vm._v(" Aceptar\n                                              ")])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.datosPer == null) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13 disabled-button2",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": !_vm.datosPer
    },
    on: {
      "click": function($event) {
        return _vm.mergePersonal()
      }
    }
  }, [_vm._v("Aceptar")])]) : _vm._e()])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalAnularTrabxApp",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("¿DESEAS\n                                  ANULAR AL PERSONAL DE ESTA APLICACIÓN?")])]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body"
  }, [_vm._v("\n                                Se anulará a " + _vm._s(_vm.trabajador.nombres) + "\n                                " + _vm._s(_vm.trabajador.apePaterno) + " " + _vm._s(_vm.trabajador.apeMaterno) + "\n                                de la aplicación\n                                "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.anularTrabxApp(_vm.trabajador)
      }
    }
  }, [_vm._v("Anular Personal")])])])])])])])])])]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "title": " ROLES",
      "icon": "fa fa-tasks"
    }
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 border-table"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "tabla-2"
  }, [_c('div', {
    staticClass: "box-header",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modalNuevoRol"
    },
    on: {
      "click": function($event) {
        return _vm.limpiarRol()
      }
    }
  }, [_vm._v("Nuevo Registro")])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "id": "tablaRoles",
      "aria-describedby": "tablaRoles_info",
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tablaRoles",
      "tabindex": "0"
    }
  }, [_vm._v("ITEM")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "ROL",
      "aria-sort": "ascending",
      "aria-controls": "tablaRoles",
      "tabindex": "0"
    }
  }, [_vm._v("ROL")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "MODIFICAR",
      "aria-controls": "tablaRoles",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  MODIFICAR\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "ANULAR",
      "aria-controls": "tablaRoles",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  ANULAR\n                                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rols), function(rol, indexRol) {
    return _c('tr', {
      key: indexRol.idRol,
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(indexRol + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rol.descripcion))]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-blue",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalNuevoRol"
      },
      on: {
        "click": function($event) {
          return _vm.verRol(rol)
        }
      }
    }, [_vm._v("O")])]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-red",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalAnularRolxApp"
      },
      on: {
        "click": function($event) {
          return _vm.verAnularRolxApp(rol)
        }
      }
    }, [_vm._v("X")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.error2.desError) + "\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalNuevoRol",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.texto)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body fs-12"
  }, [_vm._v("\n                                Descripción:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRol.descripcion),
      expression: "newRol.descripcion"
    }],
    staticClass: "form-control m-t-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newRol.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRol, "descripcion", $event.target.value)
      }
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": !_vm.newRol.descripcion
    },
    on: {
      "click": function($event) {
        return _vm.mergeRol()
      }
    }
  }, [_vm._v("Guardar")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalAnularRolxApp",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("¿DESEAS\n                                  ANULAR ESTE ROL DE ESTA APLICACIÓN?")])]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body"
  }, [_vm._v("\n                                Se anulará el rol \"" + _vm._s(_vm.rol.descripcion) + "\"\n                                de la aplicación\n                                "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.anularRolxApp()
      }
    }
  }, [_vm._v("Anular\n                                  Rol")])])])])])])])])])]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "title": " OPERACIONES",
      "icon": "fa fa-cogs"
    }
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12  border-table"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "tabla-3"
  }, [_c('div', {
    staticClass: "box-header",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modalNuevaOperacion"
    },
    on: {
      "click": function($event) {
        return _vm.limpiarOperacion()
      }
    }
  }, [_vm._v("Nuevo Registro")])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "id": "tablaOperaciones",
      "aria-describedby": "tablaOperaciones_info",
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tablaOperaciones",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  ITEM")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "ROL",
      "aria-sort": "ascending",
      "aria-controls": "tablaOperaciones",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  DESCRIPCIÓN")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "PRINCIPAL",
      "aria-controls": "tablaOperaciones",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  PRINCIPAL")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "OPE SUP",
      "aria-controls": "tablaOperaciones",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  OPE SUP\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "OPE SUP",
      "aria-controls": "tablaOperaciones",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  SECCIÓN\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "ENLACE",
      "aria-controls": "tablaOperaciones",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  ENLACE\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "ROL",
      "aria-controls": "tablaOperaciones",
      "tabindex": "0"
    }
  }, [_vm._v("ROL\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "ROL",
      "aria-controls": "tablaOperaciones",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  ÍCONO\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "ROL",
      "aria-controls": "tablaOperaciones",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  TÍTULO\n                                  ADICIONAL\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "ROL",
      "aria-controls": "tablaOperaciones",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  ÍCONO\n                                  ADICIONAL\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "ROL",
      "aria-controls": "tablaOperaciones",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  DESCRIPCIÓN\n                                  ADICIONAL\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "MODIFICAR",
      "aria-controls": "tablaOperaciones",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  MODIFICAR\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "ANULAR",
      "aria-controls": "tablaOperaciones",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                  ANULAR\n                                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.operaciones), function(operacion, indexOpe) {
    return _c('tr', {
      key: indexOpe.idOperacion,
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(indexOpe + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(operacion.descripcion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(operacion.principal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(operacion.opeSup))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(operacion.flagSeccion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(operacion.enlaceWeb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(operacion.nomRol))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(operacion.icono))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(operacion.titulo_adic))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(operacion.icono_adic))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(operacion.descripcion_adic))]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-blue",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalNuevaOperacion"
      },
      on: {
        "click": function($event) {
          return _vm.verOperacion(operacion)
        }
      }
    }, [_vm._v("O")])]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-red",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalAnularOpexApp"
      },
      on: {
        "click": function($event) {
          return _vm.verAnularOpexApp(operacion)
        }
      }
    }, [_vm._v("X")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.error3.desError) + "\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalNuevaOperacion",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "modalNuevaOperacionForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.texto)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body fs-12"
  }, [_vm._v("\n                                Descripción:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOpe.descripcion),
      expression: "newOpe.descripcion"
    }],
    staticClass: "form-control m-t-10 m-b-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newOpe.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOpe, "descripcion", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row m-b-10"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                                    Operación Superior :"), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "position-relative",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOpe.idOpeSup),
      expression: "newOpe.idOpeSup"
    }],
    staticClass: "form-control m-t-10 m-b-10 custom-cursor",
    attrs: {
      "disabled": _vm.cbOpes.length === 0 || _vm.newOpe.flagPrincipal == '1',
      "title": "No hay Operaciones Superiores registradas"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newOpe, "idOpeSup", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.cbOpes.length > 0 && _vm.newOpe.flagSeccion == 'I') ? [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _vm._l((_vm.cbOpes), function(itemOpe) {
    return _c('option', {
      key: itemOpe.idOperacion,
      domProps: {
        "value": itemOpe.idOperacion
      }
    }, [_vm._v("\n                                            " + _vm._s(itemOpe.descripcion) + "\n                                          ")])
  })] : (_vm.operaciones.length > 0 && _vm.cbOpes.length > 0 && (_vm.newOpe.flagSeccion == 'D' || _vm.newOpe.flagSeccion == 'S')) ? [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _vm._l((_vm.operaciones), function(itemOpe) {
    return _c('option', {
      domProps: {
        "value": itemOpe.idOperacion
      }
    }, [_vm._v("\n                                            " + _vm._s(itemOpe.descripcion) + "\n                                          ")])
  })] : [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("-\n                                          ")])]], 2), _vm._v(" "), (_vm.newOpe.idOpeSup !== '0' && _vm.newOpe.idOperacion === '0') ? _c('button', {
    staticClass: "clear-button",
    attrs: {
      "title": "Deshacer selección de Operación Superior actual"
    },
    on: {
      "click": _vm.resetSelection2
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    staticStyle: {
      "font-size": "14px"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                                    Rol :"), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "position-relative",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOpe.idRol),
      expression: "newOpe.idRol"
    }],
    staticClass: "form-control m-t-10 m-b-10 custom-cursor",
    attrs: {
      "disabled": _vm.rols.length === 0
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newOpe, "idRol", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.rols.length > 0) ? [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Seleccionar Rol")]), _vm._v(" "), _vm._l((_vm.rols), function(itemOpro) {
    return _c('option', {
      key: itemOpro.idOpeXRol,
      domProps: {
        "value": itemOpro.idRol
      }
    }, [_vm._v("\n                                            " + _vm._s(itemOpro.descripcion) + "\n                                          ")])
  })] : [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("No hay roles disponibles\n                                          ")])]], 2), _vm._v(" "), (_vm.newOpe.idRol !== '0' && _vm.newOpe.idOperacion === '0') ? _c('button', {
    staticClass: "clear-button",
    attrs: {
      "title": "Deshacer selección de Rol actual"
    },
    on: {
      "click": _vm.resetSelection
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    staticStyle: {
      "font-size": "14px"
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-b-10"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                                    Es Principal:"), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 m-l-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOpe.flagPrincipal),
      expression: "newOpe.flagPrincipal"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "1",
      "false-value": "0",
      "disabled": this.newOpe.idOperacion !== '0' && this.newOpe.idOpeSup !== 0
    },
    domProps: {
      "checked": Array.isArray(_vm.newOpe.flagPrincipal) ? _vm._i(_vm.newOpe.flagPrincipal, null) > -1 : _vm._q(_vm.newOpe.flagPrincipal, "1")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newOpe.flagPrincipal,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newOpe, "flagPrincipal", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newOpe, "flagPrincipal", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newOpe, "flagPrincipal", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                                    Sección:\n                                    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOpe.flagSeccion),
      expression: "newOpe.flagSeccion"
    }],
    staticClass: "form-control m-t-10",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newOpe, "flagSeccion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "I"
    }
  }, [_vm._v("I")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("D")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "S"
    }
  }, [_vm._v("S")])])])]), _vm._v("\n                                Enlace Web:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOpe.enlaceWeb),
      expression: "newOpe.enlaceWeb"
    }],
    staticClass: "form-control m-t-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newOpe.enlaceWeb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOpe, "enlaceWeb", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row m-b-10"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                                    Ícono:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOpe.icono),
      expression: "newOpe.icono"
    }],
    staticClass: "form-control m-t-10 m-b-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newOpe.icono)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOpe, "icono", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                                    Ícono Adicional:\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOpe.icono_adic),
      expression: "newOpe.icono_adic"
    }],
    staticClass: "form-control m-t-10 m-b-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newOpe.icono_adic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOpe, "icono_adic", $event.target.value)
      }
    }
  })])]), _vm._v("\n                                Título Adicional:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOpe.titulo_adic),
      expression: "newOpe.titulo_adic"
    }],
    staticClass: "form-control m-t-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newOpe.titulo_adic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOpe, "titulo_adic", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n                                Descripción Adicional:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOpe.descripcion_adic),
      expression: "newOpe.descripcion_adic"
    }],
    staticClass: "form-control m-t-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newOpe.descripcion_adic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOpe, "descripcion_adic", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": !_vm.newOpe.descripcion,
      "title": !_vm.newOpe.descripcion ? 'Para guardar, es necesario rellenar el campo Descripción' : ''
    },
    on: {
      "click": function($event) {
        return _vm.mergeOperacion()
      }
    }
  }, [_vm._v("Guardar")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalAnularOpexApp",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("¿DESEAS\n                                  ANULAR LA OPERACIÓN DE ESTA APLICACIÓN?")])]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body"
  }, [_vm._v("\n                                Se anulará la operación \"" + _vm._s(_vm.operacion.descripcion) + "\"\n                                de la aplicación.\n                                "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.anularOpexApp()
      }
    }
  }, [_vm._v("Anular\n                                  Operación")])])])])])])])])])])], 1)], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('h3', {
    staticClass: "fuente box-title p-t-5"
  }, [_vm._v("Detalle de la Aplicación:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69aba49a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Aplication_Detalle.vue
// module id = 340
// module chunks = 1